import "@fontsource/dm-sans/latin-400.css"
import "@fontsource/dm-sans/latin-500.css"
import "@fontsource/dm-sans/latin-700.css"
import "@fontsource/dm-sans/latin-800.css"
import "@fontsource/dm-mono/latin-500.css"

export const onClientEntry = () => {
  let consentRevision = 0
  let lastAnalyticsConsent

  const updateConsent = async () => {
    if (!window.UC_UI?.getServicesBaseInfo) return
    const revision = ++consentRevision

    try {
      // The UI wrapper may return a promise even with a synchronous underlying SDK.
      const services = await window.UC_UI.getServicesBaseInfo()
      if (revision !== consentRevision || !Array.isArray(services)) return
      const analytics = services.find((service) =>
        /^google analytics(?: 4)?$/i.test(service.name || ""),
      )
      const granted =
        analytics?.consent?.status === true && navigator.doNotTrack !== "1"
      if (granted === lastAnalyticsConsent) return
      lastAnalyticsConsent = granted
      window.gtag?.("consent", "update", {
        analytics_storage: granted ? "granted" : "denied",
      })
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: granted ? "consent_granted" : "consent_denied",
        consent_type: "analytics",
      })
    } catch (error) {
      console.warn(
        "Der Analytics-Einwilligungsstatus konnte nicht gelesen werden.",
        error,
      )
    }
  }

  window.addEventListener("UC_UI_INITIALIZED", updateConsent)
  window.addEventListener("UC_UI_CMP_EVENT", updateConsent)
  updateConsent()
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: "gatsby_route_change",
    page_path: `${location.pathname}${location.search}`,
    page_location: location.href,
    page_title: document.title,
  })
}
